import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CFDIIssuedListView from './CFDIIssued';
import CFDIIncomeListView from './CFDIIncome';
import WithholdingsView from './WIthholdings';
import CFDIExpenseListView from './CFDIExpense';
import CFDIPaymentListView from './CFDIPayment';
import CFDIReceivedListView from './CFDIReceived';

const TaxAccountingView = () => (
  <Routes>
    <Route path="cfdi-issued/*" element={<RolePrivateRoute component={CFDIIssuedListView} />} />
    <Route path="cfdi-income/*" element={<RolePrivateRoute component={CFDIIncomeListView} />} />
    <Route path="cfdi-expense/*" element={<RolePrivateRoute component={CFDIExpenseListView} />} />
    <Route path="cfdi-payment/*" element={<RolePrivateRoute component={CFDIPaymentListView} />} />
    <Route path="withholdings/*" element={<RolePrivateRoute component={WithholdingsView} />} />
    <Route path="cfdi-received/*" element={<CFDIReceivedListView />} />
    <Route index element={<Navigate to="cfdi-issued" replace />} />
  </Routes>
);

export default TaxAccountingView;
